import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Wrapper',
    component: () => import('../views/Wrapper.vue')
  },
  // For building out conditions, used only in local development
  // {
  //   path: '/ConditionConstructor',
  //   name: 'ConditionConstructor',
  //   component: () => import('../views/ConditionConstructor.vue')
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
